import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from '../firebase/AuthProvider';
import {BrandLoader} from '../components/ui/Logo/BrandLoader';
import {trainingAuthorAccess} from '../components/components/training/trainingAuthorAccess';

export default function TrainingAuthorRouteGuard({children}:{children:React.ReactNode}) {
 const auth=useAuth();
 if(auth.isLoading)return <BrandLoader/>;
 if(!trainingAuthorAccess(auth).canAuthor)return <Navigate to="/forbidden" replace/>;
 return <>{children}</>;
}
